import React from 'react'
import { BlogsList } from './BlogList'
import Link from 'next/link'
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'

export const AboutBlog = (props) => {
    const latestBlogs = props.latestBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const pageInfo = props.pageInfo
    const pageNavigation = props.pageNavigation

  return (
    <div className='space-y-8 px-2'>        
        <div className='space-y-5'>
            <div className='font-bold text-xl'>
                About
            </div>
            <p className='text-gray-500'>
                Welcome to StringsSG blogs! We aim to provide people a platform to connect with service providers in the sector of real estate, 
                financial investment and insurance, fitness, food catering, domestic services, repair services, wedding and event, planning aircon 
                services, beauty services, interior designing and more.
            </p>
        </div>
        <div className='space-y-5 pt-5'>
            <h1 className='font-bold text-xl'>
                Latest Blogs
            </h1>
            <BlogsList blogs={latestBlogs} listAll={true} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <div className='text-orange-600 flex justify-around'>
            {(!pageInfo?.hasPreviousPage && pageNavigation === "prev") &&           
                <Link href={"/sg/blogs"} className='p-2 flex items-center space-x-1'>
                    <FaAngleDoubleLeft/>
                    <span>
                        Prev
                    </span>
                </Link>
            }
            {pageInfo?.hasPreviousPage &&            
                <Link href={"/sg/blogs/prev/" + pageInfo?.startCursor} className='p-2 flex items-center space-x-1'>
                    <FaAngleDoubleLeft/>
                    <span>
                        Prev
                    </span>
                </Link>
            }
            {pageInfo?.hasNextPage &&        
                <Link href={"/sg/blogs/next/" + pageInfo?.endCursor} className='p-2 flex items-center space-x-1'>                    
                    <span>
                        Next
                    </span>
                    <FaAngleDoubleRight/>
                </Link>
            }   
        </div>
        
    </div>
  )
}
